import {AgentClaims} from 'Users/models/AgentClaims';
import {AsyncUserClaims, UserTypeClaimKey, UserTypeClaims} from 'Users/models/Claims';
import {loadUserClaims} from 'Users/selectors/userProfileSelectors';

const isUserEmulating = (userClaims: AsyncUserClaims) => {
  const claims = loadUserClaims(userClaims);
  let [isImpersonatingAgentUser] = [false];
  if (claims) {
    claims.userTypes.map(
      UserTypeClaims.match({
        [UserTypeClaimKey.AgentSite]: (agentClaims: AgentClaims) => {
          if (agentClaims.impersonatedAgentClaim) {
            isImpersonatingAgentUser = true;
          }
        },
        default: () => false,
      })
    );
  }
  return isImpersonatingAgentUser;
};

export {isUserEmulating};
